import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    isAuthenticated: false,
    sidebarOpen: false
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      if (user != null) {
        state.isAuthenticated = Object.prototype.hasOwnProperty.call(user, "email");
      }else {
        state.isAuthenticated = false;
      }
    },
    setSidebarOpen(state, open) {
      state.sidebarOpen = open;
    },
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    }
  },
  actions: {
  },
  modules: {
  }
})
